import { Seat, CartSeat, SeatZone, SeatPricing, SeatPriceQuantity } from '../../classes/seat';
import { PriceType } from '../../classes/price-type';
import isMobile from '../../helpers/is-mobile';

import { ZoneUpsell } from '../../classes/zone-upsell';

export function isSingleClick(disableOneClick: boolean, enableZoneUpsells: boolean, zoneUpsellEnableForMobile: boolean, seats: Array<Seat>, zoneUpsells: Array<ZoneUpsell>, selectedPriceQuantities: Array<SeatPriceQuantity>, priceTypes: Array<SeatPricing>): boolean {
    if ((selectedPriceQuantities.length > 1 || priceTypes.length > 1)) //if there are multiple price types
        return false;

    //if ((!disableOneClick) && selectedPriceQuantities.length === 0 && priceTypes.length === 0
    //    && (enableZoneUpsells && !zoneUpsells.some(zoneUpsell => zoneUpsell.currentZoneId.toString() === seats[0].tessituraSeat.zoneId)))  //this only happens on first select and price type quantities has been created yet
    //    return true;

    // Set in VB
    var disableCase1 = disableOneClick;

    // Multiple pricetypes available for selection
    var disableCase2 = (priceTypes.length > 1 || priceTypes.length === 0);

    // If selected seat has confirm prompt
    var disableCase3 = (seats[0].seatStyleCulture.confirmPrompt != null && seats[0].seatStyleCulture.confirmPrompt.length > 0);

    // Special seating options
    var disableCase4 = (seats[0].seatingOptionGroup != null);

    // Selected price type should enable upsell
    var disableCase5 = (selectedPriceQuantities.length === 1
        && (enableZoneUpsells && !(isMobile() && !zoneUpsellEnableForMobile))
        && sameZoneAndPriceType(zoneUpsells, seats[0].tessituraSeat.zoneId, selectedPriceQuantities[0].seatPricing.priceTypeId)
    );

    // Before price type is selected, but there is one available price type,
    // Price type should enable upsell
    var disableCase6 = (selectedPriceQuantities.length === 0
        && priceTypes.length === 1
        && (enableZoneUpsells && !(isMobile() && !zoneUpsellEnableForMobile))
        && sameZoneAndPriceType(zoneUpsells, seats[0].tessituraSeat.zoneId, priceTypes[0].priceTypeId)
    );

    // Multiple selected seats mean GA zone (GA zone check)
    var disableCase7 = seats.length > 1;

    return !(disableCase1 || disableCase2 || disableCase3 || disableCase4 || disableCase5 || disableCase6 || disableCase7);
}

function sameZoneAndPriceType(zoneUpsells: ZoneUpsell[], zoneId: number, priceTypeId: number) {
    return zoneUpsells.some(zoneUpsell => zoneUpsell.currentZoneId === zoneId
        && zoneUpsell.priceTypeId === priceTypeId);
}
